import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import deepOrange from '@material-ui/core/colors/deepOrange'
import orange from '@material-ui/core/colors/orange'
import ResultList from './components/resultList'
import SortButton from './components/sortButton'
import SearchBox from './components/searchBox'
import RelatedKeywords from './components/relatedKeywords'
import StartScreen from './components/startScreen'
import Pagination from 'material-ui-flat-pagination'
import axios from 'axios'
import './App.css'

axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'

const theme = createMuiTheme({
  palette: {
    primary: deepOrange,
    secondary: orange,
  },
  typography: {
    useNextVariants: true,
  },
})

const styles = theme => ({
  resultNumber: {
    marginTop: theme.spacing.unit * 2,
    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing.unit,
    },
  },
  searchContainer: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  paginationContainer: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    display: 'flex',
    justifyContent: 'center',
  },
})

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      initialResult: this.props.posts,
      keyword: '',
      posts: [],
      total: 0,
      showResult: false,
      offset: 0,
      parPage: 10,
      relatedKeywords: [],
      conditions: null,
    }
  }

  postSearchApi(params) {
    axios
      .post(process.env.REACT_APP_QA_SEARCH_ENDPOINT, JSON.stringify(params))
      .then(results => {
        let data = results.data.json
        let total = results.data.total
        let result = data
        if (result.length > 0) {
          this.setState({
            posts: result,
            showResult: true,
            total: total,
          })
        } else {
          this.setState({
            posts: [],
            showResult: false,
            total: 0,
          })
        }
        window.scrollTo(0, 0)
        if ('parentIFrame' in window) {
          window.parentIFrame.scrollTo(0, 0)
        }
      })
      .catch(() => {
        console.log('error')
      })
  }

  getRelatedApi(params, headers) {
    if (!headers) {
      headers = {}
    }
    axios({
      method: 'GET',
      url: process.env.REACT_APP_QA_RELATED_KEYWORD_ENDPOINT,
      params: params,
      headers: headers,
    })
      .then(results => {
        let data = results.data.data
        if (data.length > 0) {
          this.setState({
            relatedKeywords: data,
          })
        } else {
          this.setState({
            relatedKeywords: [],
          })
        }
      })
      .catch(() => {
        console.log('error')
      })
  }

  searchByKeyword(keyword) {
    if (keyword) {
      this.setState({ keyword: keyword, offset: 0, total: 0 })
      let params = {
        keyword: keyword,
        size: this.state.parPage,
        from: 0,
      }
      if (this.state.conditions) {
        this.setConditions(params, this.state.conditions)
      }
      this.postSearchApi(params)
      // ここから関連語検索
      params = {
        q: keyword,
      }
      this.getRelatedApi(params)
    }
  }

  filterByConditions(conditions) {
    if (this.state.keyword) {
      this.setState({
        ...this.state,
        offset: 0,
        total: 0,
        conditions: conditions
      })
      let params = {
        keyword: this.state.keyword,
        size: this.state.parPage,
        from: 0,
      }
      this.setConditions(params, conditions)
      this.postSearchApi(params)
    }
  }

  setConditions(params, conditions) {
      if (conditions.question) {
        params['use_question'] = 1
      }
      if (conditions.blog) {
        params['use_blog'] = 1
      }
      if (conditions.nihon && !conditions.seiyou) {
        params['category'] = 'ニホンミツバチ'
      }
      if (conditions.seiyou && !conditions.nihon) {
        params['category'] = 'セイヨウミツバチ'
      }
  }

  handlePagenate(offset) {
    this.setState({ offset })
    if (this.state.keyword) {
      let params = {
        keyword: this.state.keyword,
        size: this.state.parPage,
        from: offset,
      }
      if (this.state.conditions) {
        this.setConditions(params, this.state.conditions)
      }
      this.postSearchApi(params)
    }
  }

  render() {
    const { classes } = this.props
    return (
      <MuiThemeProvider theme={theme}>
        <div className={classes.root}>
          <Grid container justify="center">
            <Grid item xs={12} sm={10} md={7} lg={7}>
              <div className={classes.searchContainer}>
                <SearchBox
                  search={keyword => this.searchByKeyword(keyword)}
                  keyword={this.state.keyword}
                />
              </div>
              {this.state.relatedKeywords.length > 0 ? (
                <RelatedKeywords
                  related={this.state.relatedKeywords}
                  search={keyword => this.searchByKeyword(keyword)}
                />
              ) : null}
              {!this.state.showResult && (
                <StartScreen
                  search={keyword => this.searchByKeyword(keyword)}
                />
              )}
              {this.state.showResult && (
                <div>
                  <SortButton
                    filter={(conditions) => this.filterByConditions(conditions)}
                  />
                  <div className={classes.resultNumber}>
                    検索結果: {this.state.total} 件
                  </div>
                  <ResultList posts={this.state.posts} />
                </div>
              )}
              {this.state.showResult && (
                <div className={classes.paginationContainer}>
                  <Pagination
                    limit={this.state.parPage}
                    offset={this.state.offset}
                    total={this.state.total}
                    onClick={(e, offset) => this.handlePagenate(offset)}
                    size="large"
                  />
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      </MuiThemeProvider>
    )
  }
}

Main.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Main)
